import { render, staticRenderFns } from "./SettingsContainer.vue?vue&type=template&id=fe590186&scoped=true"
import script from "./SettingsContainer.vue?vue&type=script&lang=js"
export * from "./SettingsContainer.vue?vue&type=script&lang=js"
import style0 from "./SettingsContainer.vue?vue&type=style&index=0&id=fe590186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe590186",
  null
  
)

export default component.exports